import React from "react";

const DynamicTable = ({ data, columns }) => {
    return (
        <div className="overflow-x-auto table_data">
            <table className="table query-table">
                <thead>
                    <tr>
                        {columns.map((col, idx) => (
                            <th key={idx}>
                                {col.label}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.map((row, rowIndex) => (
                        <tr key={rowIndex} className="border-t border-gray-300">
                            {columns.map((col, colIndex) => (
                                <td key={colIndex}>
                                    {col.render ? col.render(row[col.key], row) : row[col.key]}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
};

export default DynamicTable;